import { UseFormSetValue } from 'react-hook-form';
import { Address, AddressForm } from '../../../global-types';
import { FormFieldAddress } from '../../../global-types/addresses';
import { Contact } from '../../address-book';
import { parseContactFormData } from './parse-contact-form-data';

// This function sets the values of the address form based on the provided contact.
// this function is used for single address selection from the address book.
export const setAddressFormValues = (newAddress: Contact, setValue: UseFormSetValue<AddressForm>) => {
  const contactFormData: FormFieldAddress = parseContactFormData(newAddress);
  Object.keys(contactFormData).forEach((field) => {
    setValue(field as keyof Address, contactFormData[`${field}`], { shouldValidate: true });
  });
};
